import React, { memo, useEffect, useState } from "react";
import "./index.66c4e38f.css";
import "./index.0e7756c7.css";
import { Link, useLocation } from "react-router-dom";
import PendingOrders from "./PendingOrders";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import OrderOverview from "./OrderOverview";
import ReadyForPickupOrders from "./ReadyForPickupOrders";
import OrderInvoices from "../orderinvoices/OrderInvoices";
import { useDispatch, useSelector } from "react-redux";
import {
  lawFirmSelector,
  GetCurrentOrderList,
  GetLawyersByFirmID,
  GetFirmByFileID,
  GetIsCurrentFirmPromptFinancial,
} from "../../features/lawFirm/lawFirmSlice";
import { useForm } from "react-hook-form";
import ReadyforPickupDocuments from "./ReadyforPickupDocuments";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import {
  GetFirmByUserID,
  manageBillingSelector,
  setFirmIDAndName,
} from "../../features/managebilling/manageBillingSlice";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";
import {
  GetProfileDetails,
  profileSelector,
} from "../../features/profile/profileSlice";
import { exportRowToCSV, getLawfirmForInternalUser } from "../../common/utils";
import {
  GetAllFirmInvoices,
  GetReviewPaymentsCombinedResults,
  invoiceSelector,
} from "../../features/invoice/invoiceSlice";
// import 'react-tabs/style/react-tabs.css';

function OrderStatus() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userLogin } = useSelector(authLoginSelector);
  const {
    invoiceFilters,
    firmInvoices,
    selectedPastPayments,
    selectedOutstandingInvoices,
    invoiceFilterValue,
    multipleInvoicePages,
    multiplePaymentsPages,
  } = useSelector(invoiceSelector);
  const { CurrentOrderList, loading, loadingOrderList, DashboardLawfirm, lawyersByFirm, FileFirmDetails, isCurrentFirmPromptFinancial } =
    useSelector(lawFirmSelector);
  console.log("🚀 ~ OrderStatus ~ CurrentOrderList:", CurrentOrderList)
  const { firmIDAndName } = useSelector(manageBillingSelector);
  const location = useLocation();
  const [showOutstanding, setshowOutstanding] = useState(true);
  const [currentTab, setCurrentTab] = useState(
    new URLSearchParams(location.search).get("tab") || "0"
  );
  const [statusFilter, setStatusFilter] = useState(
    new URLSearchParams(location.search).get("status") || ""
  );
  const { profileDetails } = useSelector(profileSelector);

  useEffect(() => {
    dispatch(GetProfileDetails(userLogin?.userId, userLogin?.isLawyer));
  }, []);

  //  useEffect(() => {
  //  if (!firmIDAndName)
  //     dispatch(GetFirmByUserID(userLogin && userLogin?.userId));
  // }, [firmIDAndName]);

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    if (FileFirmDetails == null) {
      dispatch(GetFirmByFileID(parseInt(window.localStorage.getItem("TTFileID")), userLogin?.userId));
    }
    if (FileFirmDetails != null)
      dispatch(
        setFirmIDAndName({
          firmID: FileFirmDetails?.firmID,
          firmName: FileFirmDetails?.firmName,
          hasFirmBilling: FileFirmDetails?.hasFirmBilling,
        })
      );
  }, [FileFirmDetails])

  useEffect(() => {
    if (firmIDAndName === null)
      dispatch(GetFirmByUserID(userLogin && userLogin?.userId));
    if (firmIDAndName !== null && lawyersByFirm?.lawyers === undefined)
      dispatch(
        GetLawyersByFirmID(
          getLawfirmForInternalUser(
            firmIDAndName,
            DashboardLawfirm,
            userLogin?.internalUser
          )
        )
      );
    if (
      CurrentOrderList?.length === 0 &&
      firmIDAndName !== null &&
      userLogin?.isLawyer
    ) {
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(
            firmIDAndName,
            DashboardLawfirm,
            userLogin?.internalUser
          ) === null ? firmIDAndName?.firmID : getLawfirmForInternalUser(
            firmIDAndName,
            DashboardLawfirm,
            userLogin?.internalUser
          ),
          null,
          "",
          "All",
          DashboardLawfirm !== undefined &&
            DashboardLawfirm !== null &&
            DashboardLawfirm?.FirmID !== undefined &&
            DashboardLawfirm?.FirmID !== ""
            ? ""
            : statusFilter !== "" ? "" : userLogin?.userId.toString(),
          statusFilter || currentTab == 2 ? "Ready For Pickup" : "",
          "",
          false,
          currentLanguage
        )
      );
    }

    if (
      CurrentOrderList?.length === 0 &&
      firmIDAndName !== null &&
      !userLogin?.isLawyer
    ) {
      // dispatch(GetProfileDetails(userLogin.userId, false));
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(
            firmIDAndName,
            DashboardLawfirm,
            userLogin?.internalUser
          ),
          null,
          "",
          "All",
          "",
          statusFilter,
          "",
          false,
          "",
          "",
          statusFilter !== "" || userLogin?.internalUser ? "" : userLogin?.userId.toString(),
          currentLanguage
        )
      );
    }
  }, [CurrentOrderList, firmIDAndName, statusFilter]);

  useEffect(() => {
    if (DashboardLawfirm && DashboardLawfirm?.FirmID !== undefined) {
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(
            firmIDAndName,
            DashboardLawfirm,
            userLogin?.internalUser
          ),
          null,
          "",
          "All",
          DashboardLawfirm !== undefined &&
            DashboardLawfirm !== null &&
            DashboardLawfirm?.FirmID !== undefined &&
            DashboardLawfirm?.FirmID !== ""
            ? ""
            : statusFilter !== "" ? "" : userLogin?.userId.toString(),
          statusFilter,
          "",
          false,
          currentLanguage
        )
      );
    }
  }, [DashboardLawfirm, statusFilter]);



  useEffect(() => {
    if (firmIDAndName?.firmID && !userLogin?.internalUser)
      dispatch(GetIsCurrentFirmPromptFinancial(firmIDAndName?.firmID));
  }, [firmIDAndName]);

  //seperated since for internal user api hits 3 times
  useEffect(() => {
    if (userLogin?.internalUser) {
      dispatch(GetIsCurrentFirmPromptFinancial(parseInt(localStorage?.getItem("selectedFirmId"))));
    }
  }, []);

  return (
    <div
      role="main"
      aria-label="Main Content"
      className="font-open-sans pt-[100px] min-h-screen-80"
    >
      <div className="flex justify-center">
        <div className="overview section">
          <div className="!w-[1060px] flex justify-between">
            <h1 className="font-[700] leading-[26.82px] text-[22px]">
              {t("MyOrderHeading")}
            </h1>
          </div>{" "}
          <Tabs defaultIndex={currentTab}>
            <div className="flex justify-between items-center mt-[20px]">
              <TabList className="flex font-open-sans gap-[1px]">
                <Tab
                  className="addicional-nav border-secondary-blue hover:bg-[#F8F8F8] pb-[15px] px-[20px] py-[20px] text-neutrals-black"
                  selectedClassName="border-b-[#ffcd34] border-b-[3px] font-bold"
                  onClick={() => setCurrentTab(0)}
                  style={{ cursor: "pointer" }}
                >
                  <Link to="?tab=0">{t("OverViewHeading")}</Link>
                </Tab>
                <Tab
                  className="addicional-nav border-secondary-blue hover:bg-[#F8F8F8] pb-[15px] px-[20px] py-[20px] text-neutrals-black"
                  selectedClassName="border-b-[#ffcd34] border-b-[3px] font-bold"
                  onClick={() => setCurrentTab(1)}
                  style={{ cursor: "pointer" }}
                >
                  <Link to="?tab=1">{t("PendingOrderheading")}</Link>
                </Tab>
                <Tab
                  className="addicional-nav border-secondary-blue hover:bg-[#F8F8F8] pb-[15px] px-[20px] py-[20px] text-neutrals-black"
                  selectedClassName="border-b-[#ffcd34] border-b-[3px] font-bold"
                  onClick={() => setCurrentTab(2)}
                  style={{ cursor: "pointer" }}
                >
                  <Link to="/orderstatus/?tab=2">{t("PolicyPickupHeading")}</Link>
                </Tab>
                <Tab
                  className="addicional-nav border-secondary-blue hover:bg-[#F8F8F8] pb-[15px] px-[20px] py-[20px] text-neutrals-black"
                  selectedClassName="border-b-[#ffcd34] border-b-[3px] font-bold"
                  onClick={() => setCurrentTab(3)}
                  style={{ cursor: "pointer" }}
                >
                  <Link to="?tab=3">{t("MakeaPayment")}</Link>
                </Tab>
              </TabList>

              {window.location.href.includes("orderstatus?tab=3") && (
                <button
                  className="ml-4 flex items-center px-3 py-2 bg-white hover:bg-gray-100"
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    if (
                      showOutstanding &&
                      selectedOutstandingInvoices?.length > 0
                    ) {
                      const selectedIds = selectedOutstandingInvoices?.map(
                        (item) => item?.invoiceID
                      );
                      if (selectedIds?.length > 0) {
                        const payments = firmInvoices?.filter((item) =>
                          selectedIds?.includes(item.invoiceID)
                        );
                        exportRowToCSV(payments, "", "outstandingInvoices", t);
                      }
                    } else if (
                      !showOutstanding &&
                      selectedPastPayments?.length > 0
                    ) {
                      const payments = await dispatch(
                        GetReviewPaymentsCombinedResults({
                          firmID: getLawfirmForInternalUser(
                            firmIDAndName,
                            DashboardLawfirm,
                            userLogin?.internalUser
                          ),
                          lawyerID: userLogin?.userId || "-1",
                          userID: userLogin?.userId,
                          dateRangeStart: "",
                          dateRangeEnd: "",
                          paymentMethod: "",
                          searchText: "",
                          sortColumn: "",
                          sortOrder: "",
                          totalRangeStart: null,
                          totalRangeEnd: null,
                          pageNumber: 1,
                          isLawyer: userLogin?.isLawyer,
                          PaymentID: selectedPastPayments
                            ?.map((item) => item?.paymentID)
                            ?.join(", "),
                          PaymentType: "",
                        })
                      );
                      exportRowToCSV(payments, "", "pastPayments", t);
                    } else if (invoiceFilters) {
                      if (invoiceFilterValue[0] === "OutstandingFilters") {
                        if (multipleInvoicePages) {
                          const totalFirmInvoices = await dispatch(
                            GetAllFirmInvoices({
                              FirmID: getLawfirmForInternalUser(
                                firmIDAndName,
                                DashboardLawfirm,
                                userLogin?.internalUser
                              ),
                              Paid: false,
                              userID: userLogin?.userId,
                              commercial: invoiceFilterValue[1].DealType || 2,
                              Lawyer: invoiceFilterValue[1].LawyerName || "",
                              // closeDate: (!Array.isArray(invoiceFilterValue[1]?.closingDate) && moment(invoiceFilterValue[1]?.closingDate).format("DD/MM/YYYY")) || "",
                              DateRangeStart:
                                (Array.isArray(
                                  invoiceFilterValue[1]?.closingDate
                                ) &&
                                  invoiceFilterValue[1].closingDate?.length >
                                  0 &&
                                  invoiceFilterValue[1].closingDate[0] !== "" &&
                                  moment(
                                    invoiceFilterValue[1].closingDate[0]
                                  ).format("DD/MM/YYYY")) ||
                                "",
                              DateRangeEnd:
                                (Array.isArray(
                                  invoiceFilterValue[1]?.closingDate
                                ) &&
                                  invoiceFilterValue[1].closingDate?.length >
                                  0 &&
                                  invoiceFilterValue[1].closingDate[0] !== "" &&
                                  moment(
                                    invoiceFilterValue[1].closingDate[1]
                                  ).format("DD/MM/YYYY")) ||
                                "",
                              BillingType:
                                invoiceFilterValue[1].paymentMethod || "",
                              SelectedFilelanguage: "",
                              SearchText: invoiceFilterValue[1]?.search || "",
                              SortColumn: "",
                              SortOrder: "",
                              TotalRangeStart:
                                invoiceFilterValue[1]?.rangeValue?.length > 0
                                  ? invoiceFilterValue[1]?.rangeValue[0]
                                  : "",
                              TotalRangeEnd:
                                invoiceFilterValue[1]?.rangeValue?.length > 0
                                  ? invoiceFilterValue[1]?.rangeValue[1]
                                  : "",
                            })
                          );
                          if (totalFirmInvoices) {
                            exportRowToCSV(
                              totalFirmInvoices,
                              "",
                              "outstandingInvoices",
                              t
                            );
                          }
                        } else
                          exportRowToCSV(
                            firmInvoices,
                            "",
                            "outstandingInvoices",
                            t
                          );
                      } else if (invoiceFilterValue[0] === "PastPayments") {
                        // if (multiplePaymentsPages) {
                        const totalFirmInvoices = await dispatch(
                          GetReviewPaymentsCombinedResults({
                            firmID: getLawfirmForInternalUser(
                              firmIDAndName,
                              DashboardLawfirm,
                              userLogin?.internalUser
                            ),
                            isLawyer: userLogin?.isLawyer,
                            userID: userLogin?.userId,
                            lawyerID: invoiceFilterValue[1]?.LawyerName,
                            DateRangeStart:
                              (Array.isArray(
                                invoiceFilterValue[1]?.closingDate
                              ) &&
                                invoiceFilterValue[1]?.closingDate?.length >
                                0 &&
                                invoiceFilterValue[1].closingDate[0] !== "" &&
                                invoiceFilterValue[1]?.closingDate[0]) ||
                              "",
                            DateRangeEnd:
                              (Array.isArray(
                                invoiceFilterValue[1]?.closingDate
                              ) &&
                                invoiceFilterValue[1]?.closingDate?.length >
                                0 &&
                                invoiceFilterValue[1].closingDate[0] !== "" &&
                                invoiceFilterValue[1]?.closingDate[1]) ||
                              "",
                            paymentMethod:
                              invoiceFilterValue[1]?.paymentMethod || "",
                            searchText: invoiceFilterValue[1]?.search || "",
                            sortColumn: "",
                            sortOrder: "",
                            TotalRangeStart:
                              (invoiceFilterValue[1]?.rangeValue?.length > 0 &&
                                invoiceFilterValue[1]?.rangeValue[0]) ||
                              null,
                            TotalRangeEnd:
                              (invoiceFilterValue[1]?.rangeValue?.length > 0 &&
                                invoiceFilterValue[1]?.rangeValue[1]) ||
                              null,
                            PaymentID: "",
                            PaymentType: "",
                          })
                        );
                        if (totalFirmInvoices) {
                          exportRowToCSV(totalFirmInvoices, "", "pastPayments", t);
                        }
                        // }
                        // else exportRowToCSV(pastPayments, "", "pastPayments");
                      }
                    } else {
                      const totalFirmInvoices = await dispatch(
                        showOutstanding
                          ? GetAllFirmInvoices({
                            FirmID: getLawfirmForInternalUser(
                              firmIDAndName,
                              DashboardLawfirm,
                              userLogin?.internalUser
                            ),
                            Paid: false,
                            userID: userLogin?.userId,
                            commercial: 2,
                            Lawyer: "",
                            closeDate: "",
                            DateRangeStart: "",
                            DateRangeEnd: "",
                            BillingType: "",
                            SelectedFilelanguage: currentLanguage === "en" ? "en-CA" : "fr-CA",
                            SearchText: "",
                            SortColumn: "",
                            SortOrder: "",
                            TotalRangeStart: null,
                            TotalRangeEnd: null,
                            pageNumber: -1,
                            isLawyer: userLogin?.isLawyer,
                          })
                          : GetReviewPaymentsCombinedResults({
                            firmID: getLawfirmForInternalUser(
                              firmIDAndName,
                              DashboardLawfirm,
                              userLogin?.internalUser
                            ),
                            lawyerID: userLogin?.userId || "-1",
                            userID: userLogin?.userId,
                            dateRangeStart: "",
                            dateRangeEnd: "",
                            paymentMethod: "",
                            searchText: "",
                            sortColumn: "",
                            sortOrder: "",
                            totalRangeStart: null,
                            totalRangeEnd: null,
                            pageNumber: 1,
                            isLawyer: userLogin?.isLawyer,
                            PaymentID: "",
                            PaymentType: "",
                          })
                      );
                      if (totalFirmInvoices) {
                        exportRowToCSV(
                          totalFirmInvoices,
                          "",
                          showOutstanding
                            ? "outstandingInvoices"
                            : "pastPayments",
                          t
                        );
                      }
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="mr-2"
                  >
                    <path d="M6 2h9l5 5v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="9" y1="13" x2="15" y2="13" />
                    <line x1="9" y1="17" x2="15" y2="17" />
                    <line x1="9" y1="9" x2="9.01" y2="9" />
                  </svg>
                  <strong className="text-black">export.csv</strong>
                </button>
              )}
            </div>

            <hr className="mb-6" />

            <TabPanel>
              <OrderOverview
                overviewOrders={
                  CurrentOrderList && CurrentOrderList?.lstOrdersOverView
                    ? CurrentOrderList?.lstOrdersOverView
                    : []
                }
                firmIDAndName={firmIDAndName}
                profileDetails={profileDetails}
                statusFilter={statusFilter}
                isCurrentFirmPromptFinancial={isCurrentFirmPromptFinancial}
              />
            </TabPanel>

            <TabPanel>
              <PendingOrders
                pendingOrders={
                  CurrentOrderList && CurrentOrderList?.lstOrdersPending
                    ? CurrentOrderList?.lstOrdersPending
                    : []
                }
                firmIDAndName={firmIDAndName}
              />
            </TabPanel>
            <TabPanel>
              <ReadyForPickupOrders
                readyForPickOrders={
                  CurrentOrderList && CurrentOrderList?.lstOrdersReadyForPick
                    ? CurrentOrderList?.lstOrdersReadyForPick
                    : []
                }
                firmIDAndName={firmIDAndName}
              />
              {/* <ReadyforPickupDocuments/> */}
            </TabPanel>
            <TabPanel>
              <OrderInvoices
                location={location}
                firmIDAndName={firmIDAndName}
                userLogin={userLogin}
                DashboardLawfirm={DashboardLawfirm}
                showOutstanding={showOutstanding}
                setshowOutstanding={setshowOutstanding}
              />
            </TabPanel>
          </Tabs>{" "}
        </div>
      </div>
      {loading || loadingOrderList ? <Loader /> : ""}
    </div>
  );
}

export default memo(OrderStatus);
